import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export const createSamplingIntent = async (
  productId: string,
  body: { product_quote: number; discount_id?: string }
) => {
  try {
    const response = await apiService.post<any>(
      `/products/${productId}/samples`,
      body
    );

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default createSamplingIntent;
